module.exports = __webpack_public_path__ + "media/images/icons/twotone/minus-circle-0927b3e753d9fa74c30ace293ab875bc.svg";